export enum PublishedMediaMetadataMigrationStatus {
  Pending = 0,
  Running = 1,
  Completed = 2,
  Failed = 3,
  Cancelled = 4,
  CompletedWithExceptions = 5,
  Cancelling = 6,
}

export interface PublishedMediaMetadataMigrationStartRequest {
  resumeJobId?: string;
  retryExceptions?: boolean;
}

export interface PublishedMediaMetadataMigrationWorkerStatus {
  workerEnabled?: boolean;
}

export interface PublishedMediaMetadataMigrationCounters {
  scanned: number;
  updated: number;
  skipped: number;
  fileMissing: number;
  ambiguous: number;
  exceptions: number;
  conflicts: number;
}

export interface PublishedMediaMetadataMigrationJob {
  id: string;
  status: PublishedMediaMetadataMigrationStatus;
  createdAtUtc?: string;
  startTime: string;
  endTime?: string;
  heartbeatAtUtc?: string;
  continuationToken?: string;
  pageNumber: number;
  cancellationRequested: boolean;
  errorMessage?: string;
  canResume: boolean;
  canRetryExceptions: boolean;
  mediaMigrationCounters?: PublishedMediaMetadataMigrationCounters;
}

export function isPublishedMediaMigrationActive(
  status?: PublishedMediaMetadataMigrationStatus
) {
  return (
    status === PublishedMediaMetadataMigrationStatus.Pending ||
    status === PublishedMediaMetadataMigrationStatus.Running ||
    status === PublishedMediaMetadataMigrationStatus.Cancelling
  );
}
